export const LOCAL_STORAGE_KEYS = {
  SEND_AGAIN_CLICK_COUNT: 'sendAgainClickCount',
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  TOKEN_EXPIRY: 'tokenExpiry',
  ID_TOKEN: 'id_token',
  AUTH_V2: 'authV2',
  BROWSER_UNIQUE_ID: 'browserUniqueId',
  PRODUCT_SOURCE: 'productSource',
  PRODUCT_TYPE: 'productType',
  GITHUB_INSTALLATION_STATE: 'githubInstallationState',
  AZURE_INSTALLATION_STATE: 'azureInstallationState',
  MT_MARKETPLACE_INSTALLATION_STATE: 'mtMarketplaceInstallationState',
  ONBOARDING_WIZARD_COMPLETED: 'onboardingWizardCompleted',
  REDIRECT_TO: 'redirectTo',
  CROSS_DOMAIN_REDIRECT_IN_PROGRESS: 'crossDomainRedirectInProgress',
  /** Integration whose connect flow is in progress; set before the OAuth tab
   *  opens, consumed back on the integrations page to auto-enable its research
   *  preview. Shared across tabs so it survives the OAuth round-trip. */
  PENDING_RESEARCH_PREVIEW_CONNECT: 'pendingResearchPreviewConnect',
  LAST_USED_AUTH_PROVIDER: 'lastUsedAuthProvider',
} as const;

/** How long the cross-domain redirect guard is considered active after being set. */
export const CROSS_DOMAIN_REDIRECT_TTL_MS = 30_000;
